import React, { useState, useEffect } from 'react';
import {
    TextField,
    IconButton,
    Box,
    Tooltip
} from '@mui/material';
import {
    Save as SaveIcon,
    Cancel as CancelIcon
} from '@mui/icons-material';


// Компонент редактирования названия группы
const GroupNameEditor = ({ groupName, onSave, onCancel }) => {
    const [name, setName] = useState(groupName);

    const handleSubmit = () => {
        if (name.trim()) {
            onSave(name.trim());
        }
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <TextField
                autoFocus
                size="small"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
                variant="outlined"
                sx={{ flexGrow: 1 }}
                placeholder="Введите название группы"
            />
            <Tooltip title="Сохранить">
                <IconButton
                    onClick={handleSubmit}
                    color="primary"
                    disabled={!name.trim()}
                >
                    <SaveIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title="Отмена">
                <IconButton onClick={onCancel} color="error">
                    <CancelIcon />
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default GroupNameEditor;